// Satış Ekranları listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.quickSalePage';

export const quickSalePageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Satış ekranları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu sayfada şirketinizin kasa ekranlarını tanımlar, açar ve ayarlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve yeni ekran'),
    filters: t(`${G}.regions.filters`, 'Şube ve arama'),
    toolbar: t(`${G}.regions.toolbar`, 'Satır menüsü'),
    table: t(`${G}.regions.table`, 'Ekran listeleri'),
  },
  steps: [
    {
      region: 'table',
      title: t(`${G}.s1.title`, '1. Ekran tipleri'),
      text: t(`${G}.s1.text`, 'Sayfada iki liste vardır: "Hızlı Satış Ekranları" market / kafe kasası gibi barkodla hızlı satış içindir; "PYK Ekranları" ayrı bir ekran tipidir ve kendi ayarlarıyla çalışır. Her satırda ekranın adı ve atandığı şube görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Restoran (masa / adisyon) ve paket sipariş ekranları bu listede görünmez; kendi bölümlerinden yönetilir.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Yeni ekran ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Satış Ekranı" düğmesi yeni bir hızlı satış ekranı açar: "Ekran Adı / Tanımlayıcı" zorunludur (örn. Kasa 1 - Market), şube isteğe bağlıdır. PYK ekranı için ⋮ menüsünden "PYK Ekranı Ekle"yi seçin.'),
      tips: [
        t(`${G}.s2.tip1`, '⋮ menüsünde ayrıca Genel Duyuru Sistemi, Gün Sonu Raporu, Gün Sonları Listesi ve yazdırma servisinin Windows / Mac indirme bağlantıları bulunur.'),
        t(`${G}.s2.tip2`, 'Fiş ve adisyon yazdırmak için kasa bilgisayarına yazdırma servisini kurun.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Şube ve ada göre süzün'),
      text: t(`${G}.s3.text`, 'Şube seçimi ve arama kutusu iki listeyi birlikte süzer. Sağdaki sayı, kaç ekranın gösterildiğini söyler.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Ekranı açın'),
      text: t(`${G}.s4.text`, '"Ekrana Git" düğmesine ya da ekran adına tıklayınca satış ekranı açılır ve kasada satışa başlayabilirsiniz.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Ayarlar, raporlar ve geçmiş'),
      text: t(`${G}.s5.text`, 'Satırın sonundaki ⋮ menüsünden: "Düzenle" ad ve şubeyi değiştirir, "Ayarlar" ödeme türleri, yazarkasa, yazdırma ve personel yetkilerini açar, "Raporlar" o ekranın satışlarını gösterir, "Bu Ekrana Özel Duyurular" yalnız o kasada çıkan duyuruları yönetir. "İşlem Geçmişi" ekran ayarlarında kimin ne zaman ne değiştirdiğini gösterir.'),
      tips: [
        t(`${G}.s5.tip1`, 'PYK satırlarının menüsünde yalnız Raporlar, Ayarlar, Bu Ekrana Özel Duyurular ve Sil bulunur.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Ekranı silme'),
      text: t(`${G}.s6.text`, '⋮ menüsündeki "Sil" onay sorar; silinen ekran listeden kalkar ve bu işlem geri alınamaz. Yalnız ekran tanımı kaldırılır; o ekrandan yapılmış satış kayıtları silinmez.'),
      tips: [
        t(`${G}.s6.tip1`, 'Hızlı satış ekranına bağlı restoran ve paket sipariş ekranı varsa onlar da birlikte silinir.'),
      ],
    },
  ],
});
